const handleInstallPromotion = (banner: HTMLElement, btn: HTMLButtonElement, closeBtn: HTMLButtonElement) => {
  let deferredPrompt: any;
  let newVariable: any;

  newVariable = window.navigator;
  banner.style.display = "none";

  window.addEventListener("appinstalled", evt => {
    console.log("a2hs installed");
  });

  window.addEventListener("load", () => {
    console.log("load");
    if (newVariable.standalone) {
      console.log("Launched: Installed (iOS)");
    } else if (matchMedia("(display-mode: standalone)").matches) {
      console.log("Launched: Installed");
      // let body = document.querySelector("body");
      // if (body) body.style.background = "#36393f";
    } else {
      console.log("Launched: Browser Tab");
    }
  });

  window.addEventListener("beforeinstallprompt", e => {
    console.log("beforeinstallprompt");
    e.preventDefault();
    deferredPrompt = e;
    console.log(banner, e);
    if (banner) banner.style.display = "block";

    if (banner && btn && closeBtn) {
      btn.addEventListener("click", (e: any) => {
        banner.style.display = "none";
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult: any) => {
          if (choiceResult.outcome === "accepted") {
            console.log("User accepted the A2HS prompt");
          } else {
            console.log("User dismissed the A2HS prompt");
          }
          deferredPrompt = null;
        });
      });

      closeBtn.addEventListener("click", (e: any) => {
        banner.style.display = "none";
      });
    }
  });
};

export default handleInstallPromotion;
